import { useCallback, useState } from 'react';

const readStoredValue = <T>(key: string, fallback: T, isValid: (value: unknown) => value is T): T => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) {
      return fallback;
    }
    const parsed: unknown = JSON.parse(raw);
    return isValid(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
};

/** Une valeur gardée sur l'appareil, relue au montage et réécrite à chaque changement. */
const useStoredValue = <T>(key: string, fallback: T, isValid: (value: unknown) => value is T) => {
  const [value, setValue] = useState<T>(() => readStoredValue(key, fallback, isValid));

  const store = useCallback(
    (next: T) => {
      localStorage.setItem(key, JSON.stringify(next));
      setValue(next);
    },
    [key]
  );

  return [value, store] as const;
};

export default useStoredValue;
